import { render } from "./DirectSponsored.vue?vue&type=template&id=2473e51e"
import script from "./DirectSponsored.vue?vue&type=script&lang=ts"
export * from "./DirectSponsored.vue?vue&type=script&lang=ts"
script.render = render

export default script